import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { fadeIn } from 'src/app/theme/utils/app-animation';
import { MenuService } from '../../services/menu.service';
import { IMenu } from '../../responses/imenu';
import * as debug from '../../services/debug.service';

@Component({
	selector: 'app-content-header',
	templateUrl: './content-header.component.html',
	styleUrls: ['./content-header.component.scss'],
	animations: [fadeIn],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContentHeaderComponent implements OnInit {

	@Input() hasBgImage = true;
	@Input() class: string;
	@Input() activeMenu: IMenu;
	@Input() isBusy: boolean;
	@Input() picture: string;

	hideBreadcrumb = true;
	breadcrumbs = [];

	constructor(readonly menuService: MenuService) {
	}

	ngOnInit(): void {

		if (this.activeMenu) { return; }

		const activeMenu = this.menuService.getActiveMenu(`090.1 ContentHeaderComponent.ngOnInit`);

		if (!activeMenu) {
			this.activeMenu = this.menuService.getMenus('/not-found', `090.2 ContentHeaderComponent.ngOnInit`)[0];
			// this.hideBreadcrumb = true;
		} else {
			this.breadcrumbs = this.menuService.getBreadcrumbs(`090 ContentHeaderComponent.ngOnInit`);

			if (!this.breadcrumbs) { return; }

			this.hideBreadcrumb = !(this.breadcrumbs.length > 1);

			this.activeMenu = activeMenu;
			debug.log(`090.2 ContentHeaderComponent.ngOnInit activeMenu:`, [this.activeMenu], true);
		}
	}
}
